namespace Shared.Collections

type NonEmptyList<'a> = 
    {
        Head: 'a
        Tail: 'a list
    }

[<RequireQualifiedAccess>]
module NonEmptyList = 
    let create head tail = 
        {
            Head = head 
            Tail = tail
        }

    let ofList l = 
        match l with 
        | [] -> None 
        | h::tail -> create h tail |> Some

    let toList l = l.Head :: l.Tail
    
    let head x = x.Head
    let length x = List.length x.Tail + 1
    let map (mapper: 'I -> 'O) (l: NonEmptyList<'I>) : NonEmptyList<'O> = 
        {
            Head = mapper l.Head
            Tail = List.map mapper l.Tail
        } 
    let prepend item x = create item (x.Head::x.Tail)
    let min x = List.min (x.Head::x.Tail)
    let max x = List.max (x.Head::x.Tail)
    let minBy projection x = List.minBy projection (x.Head::x.Tail)
    let maxBy projection x = List.maxBy projection (x.Head::x.Tail)
    let concat2 l1 l2 = 
        create l1.Head (l1.Tail @ [ l2.Head ] @ l2.Tail)
    let iter action l = l.Head :: l.Tail |> List.iter action 
    let choose chooser x = List.choose chooser (x.Head :: x.Tail) |> ofList
    let reduce reduction = toList >> List.reduce reduction
    let exists predicate = toList >> List.exists predicate 
    let tryFind predicate = toList >> List.tryFind predicate
    let item idx = toList >> List.item idx
    let tryItem idx = toList >> List.tryItem idx